import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'
import svgcaretdown from '../svg/caret-down.svg'

import { OptionTranInfo, CurrencyInfo } from '../Types'
import { SystemHeader, FBSClientPicker } from '../CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;

var UserID: string;
var PgmCode = "OT0001" ;
var isReqAuth2:boolean = false ;

interface OptionTradeEntryViewProps {
    gsb: AxiosInstance,
    OptionTran: OptionTranInfo,
    OptionTran0: OptionTranInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


export function OptionTradeEntryView({ gsb, OptionTran = {} as OptionTranInfo, OptionTran0 = {} as OptionTranInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: OptionTradeEntryViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    console.log("OptionTradeEntryView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, OptionTran])




    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Seq" in OptionTran)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                <Button className="Col-9-2" icon="document" onClick={() => { window.open(`/#/ClientPosEnquiry?acCode=${OptionTran.d_acCode}`, '_blank') } } >Balance & Portfolio</Button>
            </div> }
            { ViewMode === "L" && <div>
                Account No. : {OptionTran.d_acCode}, {OptionTran.d_Tran_type}, {OptionTran.d_OptionNo}
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (OptionTran0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(OptionTran0.d_AuthDate, "3")} {OptionTran0.d_AuthTime} User {OptionTran0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No." labelInfo="*">
                    <InputGroup readOnly value={utils.numToString(OptionTran.d_Seq)} />
                </FormGroup>
                <FormGroup className="Col3-2-1" label="Tran Type" labelInfo="*">
                    <InputGroup readOnly value={OptionTran.d_Tran_type} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_Tran_type.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_Tran_type} </div> }
                </FormGroup>
                <FormGroup className="Col3-3-1" label="Position" labelFor="inputOption_Position" labelInfo="*">
                    <InputGroup readOnly value={OptionTran.d_Option_Position} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_Option_Position.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_Option_Position} </div> }
                </FormGroup>
                <FormGroup className="Col3-4-1" label="Option Call Put" labelFor="inputOption_CallPut" labelInfo="*">
                    <InputGroup readOnly value={OptionTran.d_Option_CallPut} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_Option_CallPut.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_Option_CallPut} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode">
                    <InputGroup readOnly value={OptionTran.d_acCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_acCode.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_acCode} </div> }
                </FormGroup>
                <FormGroup className="Col-3-3" label="Client Name">
                    <div>
                    <div id="DispText">{OptionTran.d_Name}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Option No." labelFor="inputStkNo" labelInfo="*">
                    <InputGroup readOnly value={OptionTran.d_OptionNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_OptionNo.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_OptionNo} </div> }
                </FormGroup>
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{OptionTran.d_StkCode}</div>
                    <div id="DispText"></div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-12-2" label="Market">
                    <div>
                    <div id="DispText">{OptionTran.d_Market}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Commission Code" labelFor="inputCommCode" labelInfo="*">
                    <InputGroup readOnly value={OptionTran.d_CommCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (OptionTran0.d_CommCode.toString() == "") && 
                    <div id="DispText2" > {OptionTran0.d_CommCode} </div> }
                </FormGroup>
            </div> 
        </div>
    )
}

interface OptionTradeEntryEditProps {
    gsb: AxiosInstance,
    OptionTran?: OptionTranInfo,
    isNew?: boolean,
    onSave?: (stk: OptionTranInfo) => void,
    onCancel?: () => void,
}

export function OptionTradeEntryEdit({ gsb, OptionTran = {} as OptionTranInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: OptionTradeEntryEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<OptionTranInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [showEditComm, setshowEditComm] = useState(false)

    const [AcCodeValue, setAcCodeValue] = useState(OptionTran.d_acCode)
    const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)
    const [AcName1Value, setAcName1Value] = useState(OptionTran.d_Name)
    const [AcStatusValue, setAcStatusValue] = useState("")
    const [CommCodeValue, setCommCodeValue] = useState(OptionTran.d_CommCode)
    const [OptionNoValue, setOptionNoValue] = useState(OptionTran.d_OptionNo)
    const [Caretdown2, setCaretdown2] = useState(false)
    const [StkCodeValue, setStkCodeValue] = useState(OptionTran.d_StkCode)
    const [MarketValue, setMarketValue] = useState(OptionTran.d_Market)
    const [CurrencyValue, setCurrencyValue] = useState(OptionTran.d_Currency)

    const [TranTypeValue, setTranTypeValue] = useState(OptionTran.d_Tran_type)
    const [Option_PositionValue, setOption_PositionValue] = useState(OptionTran.d_Option_Position)
    const [Option_CallPutValue, setOption_CallPutValue] = useState(OptionTran.d_Option_CallPut)

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [showChannel, setshowChannel] = useState(false)
    const [showMULTI_PRCE, setshowMULTI_PRCE] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

                setshowChannel( GsbFlag.MULTI_CHNL ) ;
                setshowMULTI_PRCE( GsbFlag.MULTI_PRCE ) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    const [o_Doc_No, seto_Doc_No] = useState("")

    let o_acCode = OptionTran.d_acCode




    useEffect(() => {
        // Call reset to get the values of record OptionTranInfo 
        if ("d_Seq" in OptionTran) {
            reset(OptionTran)
        }
    }, [OptionTran, reset])

    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])



    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: AcCodeValue})
                //console.log("StkDepWithTranEntryEdit GetACInfo data : ", res.data.data) 
                //console.log("StkDepWithTranEntryEdit GetACInfo  count: ", res.data.count) 
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {
                    setAcName1Value(res.data.data[0].d_acName1)
                    setAcStatusValue(res.data.data[0].d_status)
                    if ( o_acCode != AcCodeValue ) {
                        setCommCodeValue(res.data.data[0].d_CommCode)
                    }
                } else { 
                    setAcName1Value("")
                    setAcStatusValue("")
                    setCommCodeValue("")
                }
            
            } catch (error) {
                //showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue])



    useEffect(() => {
        (async () => {
            try {
                // get Stk Info
                //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: OptionNoValue})
                //console.log("StkDepWithTranEntryEdit GetStkInfo data : ", res.data.data) 
                //console.log("StkDepWithTranEntryEdit GetStkInfo  count: ", res.data.count) 
                
                if ( OptionNoValue.trim().length > 0 && res.data.count > 0 )
                {
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    setMarketValue(res.data.data[0].d_Market)
                    setCurrencyValue(res.data.data[0].d_Currency)

                } else { 
                    setStkCodeValue("")
                    setMarketValue("")
                    setCurrencyValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, OptionNoValue])



    if (! isNew && ! ("d_Seq" in OptionTran)) return null

    let acNoLength = 12


    const onSubmit = (data: OptionTranInfo) => {

        //console.log("OptionTradeEntryedit onsubmit data: ", data)
        //console.log("OptionTradeEntryedit onsubmit StkPrice: ", StkPrice)
        //console.log("OptionTradeEntryedit onsubmit data.d_StkPrice: ", data.d_StkPrice)

        // put value to json/field before write database dbf
        if ( typeof(data.d_Seq) === "undefined") {
            data.d_Seq = 0
        }

        data.d_Tran_type = TranTypeValue;
        data.d_Tran_type = data.d_Tran_type.toUpperCase();
//console.log("OptionTradeEntryedit onsubmit data.d_Tran_type: ", data.d_Tran_type)
        data.d_Option_Position = Option_PositionValue;
        data.d_Option_Position = data.d_Option_Position.toUpperCase();
        data.d_Option_CallPut = Option_CallPutValue;
        data.d_Option_CallPut = data.d_Option_CallPut.toUpperCase();

        data.d_acCode = AcCodeValue;
        if ( typeof(data.d_acCode) === "undefined" ) {
            data.d_acCode = ""
        }
        data.d_acCode = data.d_acCode.toUpperCase();
        data.d_CommCode = CommCodeValue

        data.d_OptionNo = OptionNoValue ;
        data.d_StkCode = StkCodeValue;
        data.d_Market = MarketValue;
        data.d_Currency = CurrencyValue;
   


        (async () => {
            try {
                //console.log("call OptionTradeEntryedit data", data)
                //console.log("call OptionTradeEntryedit isNew", isNew)
                const res = await gsb.post('/fbs/Transaction', {sb_data: data, cPgmId: "OptionTradeEntry", cAction: "OptionTranValidate", isNew: isNew})
                //console.log("OptionTradeEntryedit res.data.ok", res.data.ok)
                //console.log("OptionTradeEntryedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }





    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <FBSClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setAcCodeValue(ac.d_Acct); setIsClPickerOpen(false)}}/>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No." labelFor="inputSeqNo" labelInfo="*">
                    <InputGroup className="inputNumberNoSpin" disabled={true} id="inputSeqNo" name="d_Seq" autoFocus={isNew} defaultValue="0" type="number" inputRef={register} />
                    {errors.d_Seq && errors.d_Seq.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_Seq && errors.d_Seq.types && <span id="Err_msg">{errors.d_Seq.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col3-2-1" label="Tran Type" labelFor="inputTranType" labelInfo="*">
                    <select  id="inputTranType"  
                        value={TranTypeValue}
                        autoFocus
                        onChange={utils.handleStringChange(s => setTranTypeValue(s)) }
                    >
                        <option value="B">B: Buy</option>
                        <option value="S">S: Sell</option>
                    </select>
                </FormGroup>
                <FormGroup className="Col3-3-1" label="Position" labelFor="inputOption_Position" labelInfo="*">
                    <select  id="inputOption_Position"  
                        value={Option_PositionValue}
                        onChange={utils.handleStringChange(s => setOption_PositionValue(s)) }
                    >
                        <option value="O">O: Open</option>
                        <option value="C">C: Close</option>
                    </select>
                </FormGroup>
                <FormGroup className="Col3-4-1" label="Option Call Put" labelFor="inputOption_CallPut" labelInfo="*">
                    <select  id="inputOption_CallPut"  
                        value={Option_CallPutValue}
                        onChange={utils.handleStringChange(s => setOption_CallPutValue(s)) }
                    >
                        <option value="C">C: Call</option>
                        <option value="P">P: Put</option>
                    </select>
                </FormGroup>
             </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup id="inputacCode" value={AcCodeValue} defaultValue="" placeholder="Account No. ..." onChange={utils.handleStringChange(s => setAcCodeValue(s.toUpperCase())) } inputRef={register({ required: true , maxLength: acNoLength}) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_acCode && errors.d_acCode.type === "maxLength" && <span id="Err_msg">Max length is {acNoLength}</span>}
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Client Name" labelFor="inputAcName1">
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-6-1" label="Status" >
                    <div>
                    <div id="DispText">{AcStatusValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                { ! Caretdown2 && 
                    <FormGroup className="Col-1-1" label="Option No." labelFor="inputStkNo" labelInfo="*">
                        <InputGroup id="inputStkNo" value={OptionNoValue} defaultValue="" placeholder="Option No. ..." onChange={utils.handleStringChange(s => setOptionNoValue(s)) } inputRef={register({ required: true , maxLength: 6}) } />
                        {errors.d_OptionNo && errors.d_OptionNo.type === "required" && <span id="Err_msg">Option No. cannot be Blank</span>}
                        {errors.d_OptionNo && errors.d_OptionNo.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                        {errors.d_OptionNo && errors.d_OptionNo.types && <span id="Err_msg">{errors.d_OptionNo.types.message}</span>}
                    </FormGroup>
                }
                {/* <span onClick={() => { setCaretdown2(!Caretdown2) } }> {imgCaretdown} </span> */}
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{StkCodeValue}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-12-2" label="Market">
                    <div>
                    <div id="DispText">{MarketValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Commission Code" labelFor="inputCommCode" labelInfo="*">
                    <InputGroup disabled={! showEditComm} id="inputCommCode" defaultValue={CommCodeValue} value={CommCodeValue} onChange={utils.handleStringChange(s => setCommCodeValue(s))} inputRef={register({ maxLength: 2 }) } />
                    {errors.d_CommCode && errors.d_CommCode.type === "required" && (<span id="Err_msg">Commission Code cannot be Blank</span>)}
                    {errors.d_CommCode && errors.d_CommCode.type === "maxLength" && <span id="Err_msg">Max length is 2</span>}
                    {errors.d_CommCode && errors.d_CommCode.types && <span id="Err_msg">{errors.d_CommCode.types.message}</span>}
                </FormGroup>
                {/* <FormGroup label="Amend Code">
                    <Button className="Col-3-1" icon="edit" onClick={() => setshowEditComm(true) } >Amend</Button>
                </FormGroup> */}
            </div>
        </form>
    )
}

interface OptionTradeEntryMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function OptionTradeEntryMain({ gsb }: OptionTradeEntryMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as OptionTranInfo[])

    const [searchKey, setSearchKey] = useState("SeqNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchAcNo, setsearchAcNo] = useState("")
    const [searchAcName, setsearchAcName] = useState("")
    const [searchOptionNo, setsearchOptionNo] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentOptionTran, setcurrentOptionTran] = useState({} as OptionTranInfo)
    const [BlankOptionTran, setBlankOptionTran] = useState({} as OptionTranInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as OptionTranInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as OptionTranInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")


    const [showChannel, setshowChannel] = useState(false)

    //gsb default value
    //BlankOptionTran.d_Currency = "HKD"   //no work
    BlankOptionTran.d_acCode = ""
    BlankOptionTran.d_Tran_type = "B"
    BlankOptionTran.d_Option_Position = "O"
    BlankOptionTran.d_Option_CallPut = "C"

    //console.log("OptionTradeEntryMain url: ", url)
    //console.log("OptionTradeEntryMain qString: ", qString)
    //console.log("OptionTradeEntryMain logKey: ", logKey)
    //console.log("OptionTradeEntryMain logKey2: ", logKey2)
    //console.log("OptionTradeEntryMain logviewonly: ", logviewonly)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("OptionTradeEntryMain disp user_key: ", res.data.Flag.user_key)
                //console.log("OptionTradeEntryMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("OptionTradeEntryMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("OptionTradeEntryMain disp GsbFlag: ", GsbFlag)
                //console.log("OptionTradeEntryMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("OptionTradeEntryMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("OptionTradeEntryMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("OptionTradeEntryMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("OptionTradeEntryMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("OptionTradeEntryMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])


    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/fbs/Transaction', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "OptionTradeEntry", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("PayRecTranEntryMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
    

    const PrevRecProcess = async (OptionTran: OptionTranInfo) => {
        try {
            //console.log("call PrevRecProcess", OptionTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: OptionTran, cPgmId: "OptionTradeEntry", cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", stk.d_Seq)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setcurrentOptionTran(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_OptionNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_OptionNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (OptionTran: OptionTranInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Transaction', {sb_data: OptionTran, cPgmId: "OptionTradeEntry", cAction: "DelRec"})
            showSuccess("Seq No. " + OptionTran.d_Seq + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentOptionTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (OptionTran: OptionTranInfo) => {
        try {
            //console.log("call NextRecProcess", OptionTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: OptionTran, cPgmId: "OptionTradeEntry", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentOptionTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (OptionTran: OptionTranInfo) => {
        try {
            //console.log("call newOnSave", OptionTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: OptionTran, cPgmId: "OptionTradeEntry", cAction: "AddRec"})
            //showSuccess("Seq No. " + OptionTran.d_Seq + " record added")
            showSuccess("Seq No. " + res.data.data.d_Seq + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentOptionTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (OptionTran: OptionTranInfo) => {
        try {
            //console.log("call editOnSave", OptionTran)
            const res = await gsb.post('/fbs/Transaction', {sb_data: OptionTran, cPgmId: "OptionTradeEntry", cAction: "UpdateRec"})
            showSuccess("Seq No. " + OptionTran.d_Seq + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    //setCurrentStk(stk)
                    break
                }
            }
            //console.log("editOnSave stk", stk)
            //console.log("editOnSave res.data.data", res.data.data)
            setcurrentOptionTran(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get OptionTradeEntry list if StkNo have value
        try {
            //console.log("OptionTradeEntryMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            AcNo: searchAcNo,
                            OptionNo: searchOptionNo,
                        }, 
                    },
                    cPgmId: "OptionTradeEntry",
                    cAction: "ListRec",
                });

                console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentOptionTran(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Transaction',
                {   sb_data: {
                        d_Seq: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "OptionTradeEntry",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentOptionTran(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one OptionTradeEntry record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("OptionTradeEntryMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: "StkNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "OptionTradeEntry",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentOptionTran(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/fbs/Transaction',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                AcNo: searchAcNo,
                                OptionNo: searchOptionNo,
                            }, 
                        },
                        cPgmId: "OptionTradeEntry",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentOptionTran(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <OptionTradeEntryView gsb={gsb} OptionTran={currentOptionTran} OptionTran0={currentOptionTran} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentOptionTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentOptionTran)} onNextRec={() => NextRecProcess(currentOptionTran)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></OptionTradeEntryView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <OptionTradeEntryEdit gsb={gsb} OptionTran={BlankOptionTran} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></OptionTradeEntryEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <OptionTradeEntryEdit gsb={gsb} OptionTran={currentOptionTran} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></OptionTradeEntryEdit>
            break
        }

    let logKeyViewRec = <OptionTradeEntryView gsb={gsb} OptionTran={CurrentLog1} OptionTran0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentOptionTran)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentOptionTran)} onNextRec={() => NextRecProcess(currentOptionTran)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></OptionTradeEntryView>

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-SeqNo">Seq No</th>
                <th className="TCol-TranType">Tran Type</th>
                <th className="TCol-ACCode">Account No.</th>
                <th className="TCol-StkNo">Option No</th>
                <th className="TCol-StkCode">Stock Code</th>
                <th className="TCol-Qty1">Qty 1</th>
                <th className="TCol-Price1">Price 1</th>
                <th className="TCol-NetAmount">Net Amount</th>
                <th className="TCol-Comm">Comm Code</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((OptionTran, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-SeqNo" onClick={() => { setcurrentOptionTran(OptionTran) ; MoblieDev && setSelectedTabId("detail") }}>{OptionTran.d_Seq}</td>
                        <td className="TCol-TranType" onClick={() => { setcurrentOptionTran(OptionTran) ; MoblieDev && setSelectedTabId("detail") }}>{OptionTran.d_Tran_type}</td>
                        <td className="TCol-ACCode" onClick={() => { setcurrentOptionTran(OptionTran) ; MoblieDev && setSelectedTabId("detail") }}>{OptionTran.d_acCode}</td>
                        <td className="TCol-StkNo" onClick={() => { setcurrentOptionTran(OptionTran) ; MoblieDev && setSelectedTabId("detail") }}>{OptionTran.d_OptionNo}</td>
                        <td className="TCol-StkCode" onClick={() => { setcurrentOptionTran(OptionTran) ; MoblieDev && setSelectedTabId("detail") }}>{OptionTran.d_StkCode}</td>
                        <td className="TCol-Comm" onClick={() => { setcurrentOptionTran(OptionTran) }}>{OptionTran.d_CommCode}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Option Trade Entry</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for Client Transaction " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="SeqNo">Seq No</option>
                                    {/* <option value="acCode">Account No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "SeqNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        <Button className="Col-9-1 Button-LabeledFormGroup" icon="document" onClick={() => { window.open(`/#/OptionTranCheckList`, '_blank') } } >Check List</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-1" label="Account No" labelFor="searchAcNo">
                                <InputGroup id="searchAcNo" value={searchAcNo} onChange={utils.handleStringChange(s => setsearchAcNo(s))} />
                            </FormGroup>
                        </div>
                        <div className="Row">
                            <FormGroup className="Col-1-1" label="Option No." labelFor="searchOptionNo">
                                <InputGroup id="searchOptionNo" value={searchOptionNo} onChange={utils.handleStringChange(s => setsearchOptionNo(s))} />
                            </FormGroup>
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Option Trade Entry Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default OptionTradeEntryMain